import { useParams } from "react-router-dom";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { dataGridNestedColumnGetter } from "../../actprep-ui/utils/tables";
import PaginatedTable from "../../actprep-ui/components/PaginatedTable";
import { sexyBooleanColumn } from "../../actprep-ui/constants/dataGrid";
import { useGet } from "../../actprep-ui/hooks/api";
import { useCallback } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { fullName } from "../../actprep-ui/utils/formatting";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";

const goodNewsTextIntro = (item, i) => {
  if (item.student.school) {
    return `${i + 1}. ${fullName(item.student)} (${
      item.student.school?.name || "No School"
    })${item.current_team ? `(${item.current_team})` : ""}`;
  }
  return `${i + 1}. ${fullName(item.student)} ${
    item.current_team ? `(${item.current_team})` : ""
  }`;
};

const isReviewWeek = (weekString) => {
  const [subject] = weekString.split("_");
  return (
    ["english", "math", "review"].includes(subject) && weekString.includes("ft")
  );
};

export default function ScoreGoodNews({ filters }) {
  const { goodNewsType } = useParams();
  const { data: thirtySixClubData } = useGet(
    apiUrls.admin.goodNews("total-increase"),
    {
      params: {
        search_params: {
          ...filters,
          "36_club": true,
        },
      },
    }
  );
  const tableApiRef = useGridApiRef();

  const copyGoodNews = useCallback(async () => {
    const formatRow = (week, i) => {
      return [
        `${goodNewsTextIntro(week, i)}:`,
        `${week.total_increase ?? 0}`,
        `point(s)`,
        "-",
        `${week.increase ?? 0}`,
        "this week.\n",
      ].join(" ");
    };
    const format36Row = (week, i) => {
      const startScore = week.student[`start_${week.class_subject}`];
      return [
        `${goodNewsTextIntro(week, i)}`,
        `${week.total_increase ?? 0}`,
        `point(s)`,
        "-",
        `${startScore ?? 0}-${week.best_score ?? 0}\n`,
      ].join(" ");
    };

    const data = tableApiRef.current
      .getSortedRows()
      .filter((week) => week.student.show_on_good_news)
      .splice(0, 10);

    const reviewWeek = data.length ? isReviewWeek(data[0].class_week) : false;

    const club36Text = `36 Club:\n${thirtySixClubData.data
      .map(format36Row)
      .join("")}`;
    const goodNews =
      (reviewWeek ? "" : club36Text) +
      `\nTop Increases Good News:\n${data.map(formatRow).join("")}`;

    await navigator.clipboard.writeText(goodNews);
    showSuccessSnackbar("Copied!");
  }, [tableApiRef, thirtySixClubData]);
  const columns = [
    {
      field: "student.first_name",
      headerName: "First name",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "student.last_name",
      headerName: "Last name",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "total_increase",
      headerName: "Total Increase",
    },
    {
      field: "increase",
      headerName: "This Week Increase",
    },
    {
      field: "start_score",
      headerName: "Start Score",
    },
    {
      field: "best_score",
      headerName: "Best Score",
    },
    {
      field: "quiz_average",
      headerName: "Quiz Average",
      valueFormatter: (val) => Math.round(val),
    },
    {
      field: "student.school.name",
      headerName: "School",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "current_team",
      headerName: "Team",
      valueGetter: dataGridNestedColumnGetter,
    },
    {
      field: "in_the_game",
      headerName: "In The Game",
      renderCell: sexyBooleanColumn,
    },
  ];
  return (
    <PaginatedTable
      apiRef={tableApiRef}
      pagination={false}
      tableName={"Score Good News"}
      apiUrl={apiUrls.admin.goodNews(goodNewsType)}
      urlParams={{
        search_params: filters,
      }}
      columns={columns}
      alwaysShowActions
      actions={[
        {
          label: "Copy Text Message",
          onClick: copyGoodNews,
        },
      ]}
    />
  );
}
